import { render, staticRenderFns } from "./VueTableWin.vue?vue&type=template&id=ab80dc0e&scoped=true&"
import script from "./VueTableWin.vue?vue&type=script&lang=js&"
export * from "./VueTableWin.vue?vue&type=script&lang=js&"
import style0 from "./VueTableWin.vue?vue&type=style&index=0&id=ab80dc0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab80dc0e",
  null
  
)

export default component.exports